 import {
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';

import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

import Home from './pages/Home/Home';
import SignIn from './pages/SignIn/SignIn';
import SSOAuthRedirect from './pages/SSOAuthRedirect/SSOAuthRedirect';
import ProtectedRoute from './routes/PrivateRoute';
import Account from './pages/Account/Account';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import User from './pages/User/User';
import AccountForm from './pages/Account/AccountForm';
import InvoiceForm from './pages/Invoice/InvoiceForm';
import InvoicePreview from './pages/Invoice/InvoicePreview';
import InvoiceShortLink from './pages/Invoice/InvoiceShortLink';
import InvoicePreviewWithFilters from './pages/Invoice/InvoicePreviewWithFilters';
import EstimatePreview from './pages/Estimate/EstimatePreview';
import InvoicePaymentReceiptPreview from './pages/Invoice/InvoicePaymentReceiptPreview';
import Navigation_v2 from './components/Drawer/Navigation_v2';
import UserForm from './pages/User/UserForm';
import UserDetails from './pages/UserDetails/UserDetails';
import PageNotFound from './pages/PageNotFound/PageNotFound';
import { PermissionsEnum } from './utils/auth.types';
import SignUp from './pages/SignUp/SignUp';
import AccountBasicInfoForm from './pages/AccountBasicInfo/AccountBasicInfoForm';
import AccountInfo from './pages/AccountInfo/AccountInfo';
// import Inventory from './pages/Ops/Inventory';

import AR from './pages/Dashboard/AR';
import AP from './pages/Dashboard/AP';
import AccountReceivable from './pages/AccountReceivable/AccountReceivable';
import AccountSaleEstimate from './pages/AccountSaleEstimate/AccountSaleEstimate';
import CreditNote from './pages/Sales/CreditNote';
import Cashflow from './pages/Cashflow/Cashflow';
import AccountPayable from './pages/AccountPayable/AccountPayable';
import Customers from './pages/Customers/Customers';
import ScanInvoice from './pages/Purchase/ScanInvoice';  
import Suppliers from './pages/Suppliers/Suppliers';
import InventoryList from './pages/Inventory/InventoryList';
import Inventory from './pages/Inventory/Inventory';
import Reports from './pages/Reports/Reports';
import AccountManagement from './pages/AccountManagement/AccountManagement';
import MyProfile from './pages/MyProfile/MyProfile';
import HowToUseMagnus from './pages/HowToUseMagnus/HowToUseMagnus';
import LiveChatSupport from './pages/LiveChatSupport/LiveChatSupport';
import Settings from './pages/Settings/Settings';
import HrmsConfig from './pages/HrmsConfig/HrmsConfig';
import Config from './pages/Config/Config';
import ReceiptApplication from './pages/ReceiptApplication/ReceiptApplication';
import PaymentApplication from './pages/PaymentApplication/PaymentApplication';
import EstimateForm from './pages/Estimate/EstimateForm';
import CreditNoteForm from './pages/Sales/CreditNoteForm';
import { VocuherCategory, InvoiceRoute, ReportTypes } from './utils/common-utils';
import InventoryViewPage from './components/Inventory/InvetoryViewPage';
import InventoryLayout from './components/Inventory/InventoryLayout';
import InventoryGuide from './pages/Inventory/InventoryGuide';
import LocationsList from './components/Inventory/LocationsList';
import StockView from './components/Inventory/StockView';
import GRNList from './components/Inventory/GRNList';
import GRNForm from './components/Inventory/GRNForm';
import BatchList from './components/Inventory/BatchList';
import InventoryPurge from './components/Inventory/InventoryPurge';
import RequisitionList from './components/Inventory/RequisitionList';
import RequisitionForm from './components/Inventory/RequisitionForm';
import TransferList from './components/Inventory/TransferList';
import TransferReport from './components/Inventory/TransferReport';
import RequisitionReport from './components/Inventory/RequisitionReport';
import GRNReport from './components/Inventory/GRNReport';
import StockInHandReport from './components/Inventory/StockInHandReport';
import StockExpiryReport from './components/Inventory/StockExpiryReport';
import StockOutReport from './components/Inventory/StockOutReport';
import TransferForm from './components/Inventory/TransferForm';
import RecipeList from './components/Inventory/RecipeList';
import RecipeForm from './components/Inventory/RecipeForm';
import OpenContainersList from './components/Inventory/OpenContainersList';
import SkuVariantsList from './components/Inventory/SkuVariantsList';
import InventoryDashboard from './components/Inventory/InventoryDashboard';
import EmployeeListData from './components/Employee/EmployeeList';
import EmployeeForm from './components/Employee/EmployeeForm';
import EmployeeViewPage from './components/Employee/EmployeeViewPage';
import CustomerView from './pages/Customers/BuyerSupplier';
import TermsConditions from './pages/SignIn/TermsConditions';
import PrivacyPolicy from './pages/SignIn/PrivacyPolicy';
import OptInForm from './pages/SignIn/OptInForm';
import OptOutForm from './pages/SignIn/OptOutForm';
import ReportDetail from './components/Reports/ReportsDetails';
import ReportTable from './components/Reports/ReportsTable';
import TdsTcsTaxReport from './components/Reports/TdsTcsTaxReport';
import ExpenseManagement from './pages/ExpenseManagement';
import LowStockSummaryPage from './pages/Reports/LowStockSummaryPage';
import RateListPage from './pages/Reports/RateListPage';
import CustomItemReportPage from './pages/Reports/CustomItemReportPage';
import ItemReportByPartyPage from './pages/Reports/ItemReportByPartyPage';
import ItemPurchaseSummaryPage from './pages/Reports/ItemPurchaseSummaryPage';
import ItemSalesAndPurchaseSummaryPage from './pages/Reports/ItemSalesAndPurchaseSummaryPage';
import ProfitLossStatementPage from './pages/Reports/ProfitLossStatementPage';
import BalanceSheetPage from './pages/Reports/BalanceSheetPage';
import BalanceSheetPartyWisePage from './pages/Reports/BalanceSheetPartyWisePage';
import ExpensesJournalEntriesReportPage from './pages/Reports/ExpensesJournalEntriesReportPage';
import JournalEntriesPartyLedgerReportPage from './pages/Reports/JournalEntriesPartyLedgerReportPage';
import DayBookReportPage from './pages/Reports/DayBookReportPage';
import CashAndBankReportAllPaymentsPage from './pages/Reports/CashAndBankReportAllPaymentsPage';
import ExpenseCategoryReportPage from './pages/Reports/ExpenseCategoryReportPage';
import CostCentreReportPage from './pages/Reports/CostCentreReportPage';
import EmployeeLedgerPage from './pages/Reports/EmployeeLedgerPage';
import PartyBalancesPage from './pages/Reports/PartyBalancesPage';
import PartyLedgerJournalPage from './pages/Reports/PartyLedgerJournalPage';
import MigrateJournalEntriesPage from './pages/Reports/MigrateJournalEntriesPage';
import AccessDenied from './pages/AccessDenied/AccessDenied';
import Navigation from './components/Drawer/Navigation';
import Taxes from './pages/Taxes';
import SalaryList from './pages/Salary/SalaryList';
import SalaryView from './pages/Salary/SalaryView';
import CostCentreManagement from './pages/CostCentre/CostCentreManagement';
import ChartsOfAccount from './pages/ChartsOfAccount/ChartsOfAccount';
import GroupCategories from './pages/ChartsOfAccount/GroupCategories';
import PrimaryGroups from './pages/ChartsOfAccount/PrimaryGroups';
import SubGroups from './pages/ChartsOfAccount/SubGroups';
import Ledgers from './pages/ChartsOfAccount/Ledgers';
import GSTSettlement from './pages/Taxes/GSTSettlement';
import StatutoryCompliance from './pages/Taxes/StatutoryCompliance';
import ExpenseSettlement from './pages/ChartsOfAccount/ExpenseSettlement';
import AuditLog from './pages/AuditLog/AuditLog';
import CoaDashboard from './pages/ChartsOfAccount/CoaDashboard';
import PayrollSettings from './pages/PayrollSettings/PayrollSettings';
import EmployeeSalaryConfigForm from './pages/PayrollSettings/EmployeeSalaryConfigForm';



/**
 * App component to handle all the routes.
 */
function App() {
  return (
    <>
      <ToastContainer autoClose={2000} />
      <Routes>
        <Route path='/' element={<Navigation />}>
          <Route path="/" element={<Navigate to="home" replace />} />
          <Route path='/home' element={<ProtectedRoute><Home /></ProtectedRoute>} />

          {/* Accounts related routes */}
          <Route path='account' element={
            <ProtectedRoute requiredRole={PermissionsEnum.Account_View}>
              <Account />
            </ProtectedRoute>}
          ></Route>
          <Route path='account/create' element={
            <ProtectedRoute requiredRole={PermissionsEnum.Account_Create}>
              <AccountForm />
            </ProtectedRoute>}
          />
          <Route path='account/edit/:accountId' element={
            <ProtectedRoute requiredRole={PermissionsEnum.Account_Update}>
              <AccountForm />
            </ProtectedRoute>}
          />
          <Route path='account/account-info' element={
            <ProtectedRoute requiredRole={PermissionsEnum.Account_View}>
              <AccountInfo />
            </ProtectedRoute>}
          ></Route>
          <Route path='account/account-details/:accountId' element={
            <ProtectedRoute requiredRole={PermissionsEnum.Account_View}>
              <AccountInfo />
            </ProtectedRoute>}
          />

          {/* Users related routes */}
          <Route path='users' element={
            <ProtectedRoute requiredRole={PermissionsEnum.Users_View}>
              <User />
            </ProtectedRoute>}
          />
          <Route path='users/create' element={
            <ProtectedRoute requiredRole={PermissionsEnum.Users_Create}>
              <UserForm />
            </ProtectedRoute>}
          />
          <Route path='users/edit/:userId' element={
            <ProtectedRoute requiredRole={PermissionsEnum.Users_Update}>
              <UserForm />
            </ProtectedRoute>}
          />
          <Route path='users/permissions/:userId' element={<ProtectedRoute requiredRole={PermissionsEnum.Users_View}><User /></ProtectedRoute>} />
          <Route path='users/user-details/:userId' element={
            <ProtectedRoute requiredRole={PermissionsEnum.Users_View}>
              <UserDetails />
            </ProtectedRoute>}
          >
            <Route index element={
              <ProtectedRoute>
                <UserForm />
              </ProtectedRoute>}
            />
          </Route>

          {/* Invoice related routes */}
          {/* <Route path='sales/' element={<CreditNote />} /> */}
          <Route path='sales/' element={<AccountReceivable />} />
          <Route path='sales/:voucherType' element={<AccountReceivable />} />
          <Route path='sales/invoice/:vType/create' element={
            // <ProtectedRoute requiredRole={PermissionsEnum.Invoice_Create}>
            <InvoiceForm type={VocuherCategory.SALE} />
            /* </ProtectedRoute> */}
          />
          <Route path='sales/invoice/:vType/edit/:invoiceId' element={
            // <ProtectedRoute requiredRole={PermissionsEnum.Invoice_Update}>
            <InvoiceForm type={VocuherCategory.SALE} />
            /* </ProtectedRoute> */}
          />

          <Route path='scan-invoice' element={<ScanInvoice />} />
          <Route path='purchase/scan-invoice' element={<ScanInvoice />} />


          <Route path='purchase/invoice/:vType/create' element={
            // <ProtectedRoute requiredRole={PermissionsEnum.Invoice_Create}>
            <InvoiceForm type={VocuherCategory.PURCHASE} />
            /* </ProtectedRoute> */}
          />
          <Route path='purchase/invoice/:vType/edit/:invoiceId' element={
            // <ProtectedRoute requiredRole={PermissionsEnum.Invoice_Update}>
            <InvoiceForm type={VocuherCategory.PURCHASE} />
            /* </ProtectedRoute> */}
          />


          <Route path='account-payable/invoice/create' element={
            // <ProtectedRoute requiredRole={PermissionsEnum.Invoice_Create}>
            <InvoiceForm type={'account-payable'} />
            /* </ProtectedRoute> */}
          />
          <Route path='account-payable/invoice/edit/:invoiceId' element={
            // <ProtectedRoute requiredRole={PermissionsEnum.Invoice_Update}>
            <InvoiceForm type={'account-payable'} />
            /* </ProtectedRoute> */}
          />
          <Route path='invoice/:invoiceId/view' element={
            <InvoicePreview />
          } />
          <Route path='i/:code' element={<InvoiceShortLink />} />
          <Route path='r/:code' element={<InvoiceShortLink receipt />} />
          {/* Token-at-end shape used by the WhatsApp Meta template button:
              https://www.wareozo.com/invoice/view/<TOKEN> */}
          <Route path='invoice/view/:invoiceId' element={
            <InvoicePreview />
          } />
          <Route path='invoice/:invoiceId/preview' element={
            <InvoicePreviewWithFilters />
          } />
          <Route path='invoice-payment-receipt/:invoiceId/view' element={
            <InvoicePaymentReceiptPreview />
          }
          />
          {/* Token-at-end shape for the receipt button:
              https://www.wareozo.com/invoice-payment-receipt/view/<TOKEN> */}
          <Route path='invoice-payment-receipt/view/:invoiceId' element={
            <InvoicePaymentReceiptPreview />
          }
          />


          <Route path='sales/estimate' element={<AccountSaleEstimate />} />

          <Route path='sales/estimate/create' element={
            // <ProtectedRoute requiredRole={PermissionsEnum.Invoice_Create}>
            <EstimateForm type={'sale-estimate'} />
            /* </ProtectedRoute> */}
          />
          <Route path='sales/estimate/edit/:estimateId' element={
            // <ProtectedRoute requiredRole={PermissionsEnum.Invoice_Update}>
            <EstimateForm type={'sale-estimate'} />
            /* </ProtectedRoute> */}
          />
          <Route path='sales/delivery-note/create' element={
            // <ProtectedRoute requiredRole={PermissionsEnum.Invoice_Create}>
            <EstimateForm type={'sales-delivery-note'} />
            /* </ProtectedRoute> */}
          />
          <Route path='sales/delivery-note/edit/:docId' element={
            // <ProtectedRoute requiredRole={PermissionsEnum.Invoice_Update}>
            <EstimateForm type={'sales-delivery-note'} />
            /* </ProtectedRoute> */}
          />
          <Route path='sales/invoice/:invoiceId/view' element={
            <EstimatePreview />
          }
          />


          {/* Routing for Sales CreditNote and DebitNote */}
          <Route path='sales/credit-note' element={<CreditNote />} />
          <Route path='sales/ddinvoice/:vType/create' element={
            <InvoiceForm type={VocuherCategory.SALE} />}
          />
          <Route path='sales/ddinvoice/:vType/edit/:creditNoteId' element={
            // <ProtectedRoute requiredRole={PermissionsEnum.Invoice_Update}>
            <CreditNoteForm type={'sale-credit-note'} />
            /* </ProtectedRoute> */}
          />

          {/* <Route path='sales/debit-note' element={<CreditNote />} /> */}
          <Route path='sales/debit-note/create' element={<CreditNoteForm type={'sale-debit-note'} />}
          />
          <Route path='sales/debit-note/edit/:invoiceId' element={
            // <ProtectedRoute requiredRole={PermissionsEnum.Invoice_Update}>
            <CreditNoteForm type={'sale-debit-note'} />
            /* </ProtectedRoute> */}
          />


          {/* End Of Routing CreditNote & Debit Note  */}

          {/* Routing for Sales Non-Gst */}
          <Route path='sales/non-gst-invoice/create' element={
            // <ProtectedRoute requiredRole={PermissionsEnum.Invoice_Create}>
            <InvoiceForm type={'sale-non-gst'} />
            /* </ProtectedRoute> */}
          />

          <Route path='sales/non-gst-invoice/edit/:invoiceId' element={
            // <ProtectedRoute requiredRole={PermissionsEnum.Invoice_Update}>
            <InvoiceForm type={'sale-non-gst'} />
            /* </ProtectedRoute> */}
          />
          {/* Routing for Sales  Non-Gst */}

          <Route path='sso-auth' element={<SSOAuthRedirect />} />
          <Route path='signin' element={<SignIn />} />
          <Route path='terms-of-use' element={<TermsConditions />} />
          <Route path='privacy-policy' element={<PrivacyPolicy />} />
          <Route path='opt-in' element={<OptInForm />} />
          <Route path='opt-out' element={<OptOutForm />} />
          {/* <Route path='forgot-password' element={<ForgotPassword />} /> */}
          <Route path='reset-password' element={<ResetPassword />} />
          <Route path='*' element={<PageNotFound />} />
          <Route path='signup' element={<SignUp />} />
          <Route path='account/create-basic-info' element={<AccountBasicInfoForm />} />
          <Route path='AR' element={<AR />} />
          <Route path='AP' element={<AP />} />
          <Route path='account-receivable' element={<AccountReceivable />} />
          <Route path='account-receivable/invoice' element={<AccountReceivable />} />
          <Route path='purchases' element={<AccountPayable />} />
          <Route path='account-payable/invoice' element={<AccountPayable />} />
          <Route path='payments' element={<Cashflow />} />
          <Route path='payments/apply' element={<PaymentApplication />} />
          <Route path='expenses' element={<ExpenseManagement />} />
          <Route path='buyers' element={<Customers />} />
          <Route path='customers' element={<Navigate to="/buyers" replace />} />
          {/* Customer View path can handle both supplier, buyer, agents view page */}
          <Route path='customer/view/:customerId' element={<CustomerView />} />
          <Route path='suppliers' element={<Suppliers />} />

          {/* Inventory module: single sidebar entry -> tabbed layout. Items is the
              default tab; new sections (Locations, Stock, GRN, etc.) are tabs. */}
          <Route path='inventory' element={<InventoryLayout />}>
            <Route index element={<InventoryList />} />
            <Route path='stock' element={<StockView />} />
            <Route path='stock/in-hand-report' element={<StockInHandReport />} />
            <Route path='stock/out-report' element={<StockOutReport />} />
            <Route path='locations' element={<LocationsList />} />
            <Route path='grn' element={<GRNList />} />
            <Route path='grn/report' element={<GRNReport />} />
            <Route path='grn/new' element={<GRNForm />} />
            <Route path='grn/:id' element={<GRNForm />} />
            <Route path='batches' element={<BatchList />} />
            <Route path='requisitions' element={<RequisitionList />} />
            <Route path='requisitions/report' element={<RequisitionReport />} />
            <Route path='requisitions/new' element={<RequisitionForm />} />
            <Route path='requisitions/:id' element={<RequisitionForm />} />
            <Route path='transfers' element={<TransferList />} />
            <Route path='transfers/report' element={<TransferReport />} />
            <Route path='transfers/new' element={<TransferForm />} />
            <Route path='transfers/:id' element={<TransferForm />} />
            <Route path='recipes' element={<RecipeList />} />
            <Route path='recipes/new' element={<RecipeForm />} />
            <Route path='recipes/:id' element={<RecipeForm />} />
            <Route path='open-containers' element={<OpenContainersList />} />
            <Route path='variants' element={<SkuVariantsList />} />
            <Route path='guide' element={<InventoryGuide />} />
          </Route>
          {/* Inventory dashboard — accessible via /inventory-dashboard and the layout tab */}
          <Route path='inventory-dashboard' element={<InventoryDashboard />} />
          {/* SKU create/edit/view stay as full-page forms (no tab bar) */}
          <Route path='inventory/view/:inventoryId' element={<InventoryViewPage />} />
          <Route path='inventory/create' element={<Inventory />} />
          <Route path='inventory/edit/:inventoryId' element={<Inventory />} />
          {/* Data purge — deliberately not a tab; reachable only by URL */}
          <Route path='inventory/purge' element={<InventoryPurge />} />

          {/* People module — Employee, HRMS config, Payroll and Salary all live under /people */}
          <Route path='people' element={<Config />} />
          <Route path='people/employee' element={<EmployeeListData />} />
          <Route path='people/employee/view/:employeeId' element={<EmployeeViewPage />} />
          <Route path='people/employee/create' element={<EmployeeForm />} />
          <Route path='people/employee/edit/:employeeId' element={<EmployeeForm />} />
          <Route path='people/employee-config' element={<HrmsConfig />} />
          <Route path='people/payroll-settings' element={<ProtectedRoute><PayrollSettings /></ProtectedRoute>} />
          <Route path='people/payroll-settings/salary-config/new' element={<ProtectedRoute><EmployeeSalaryConfigForm /></ProtectedRoute>} />
          <Route path='people/payroll-settings/salary-config/:id/edit' element={<ProtectedRoute><EmployeeSalaryConfigForm /></ProtectedRoute>} />
          <Route path='people/salary/list' element={<ProtectedRoute><SalaryList /></ProtectedRoute>} />
          <Route path='people/salary/:salaryId/view' element={<ProtectedRoute><SalaryView /></ProtectedRoute>} />

          <Route path='reports' element={<Reports type={'Dashboard'} />} />

          <Route path='reports/gstr-1-sales' element={<Reports type={VocuherCategory.SALE} />} />
          <Route path='reports/gstr-2-purchase' element={<Reports type={VocuherCategory.PURCHASE} />} />
          <Route path='reports/party-ledger' element={<Reports type={ReportTypes.PARTY_LEDGER_REPORT} />} />
          <Route path='reports/party-ledger-dn' element={<Reports type={ReportTypes.PARTY_LEDGER} />} />
          <Route path="reports/tds-payable" element={<TdsTcsTaxReport type={ReportTypes.TDS_PAYABLE} />} />
          <Route path="reports/tds-receivables" element={<TdsTcsTaxReport type={ReportTypes.TDS_RECEIVEABLES} />} />
          <Route path="reports/tcs-payable" element={<TdsTcsTaxReport type={ReportTypes.TCS_PAYABLE} />} />
          <Route path="reports/tcs-receivables" element={<TdsTcsTaxReport type={ReportTypes.TCS_RECEIVEABLES} />} />
          <Route path="reports/low-stock-summary" element={<LowStockSummaryPage />} />
          <Route path="reports/stock-expiry-report" element={<StockExpiryReport />} />
          <Route path="reports/rate-list" element={<RateListPage />} />
          <Route path="reports/custom-item-report" element={<CustomItemReportPage />} />
          <Route path="reports/item-report-by-party" element={<ItemReportByPartyPage />} />
          <Route path="reports/item-purchase-summary" element={<ItemPurchaseSummaryPage />} />
          <Route path="reports/item-sales-and-purchase-summary" element={<ItemSalesAndPurchaseSummaryPage />} />
          <Route path="reports/party-wise-outstanding" element={<Reports type={ReportTypes.PARTY_WISE_OUTSTANDING} />} />
          <Route path="reports/profit-loss" element={<ProfitLossStatementPage />} />
          <Route path="reports/balance-sheet" element={<BalanceSheetPage />} />
          <Route path="reports/balance-sheet-party-wise" element={<BalanceSheetPartyWisePage />} />
          <Route path="reports/journal-entries-party" element={<ExpensesJournalEntriesReportPage />} />
          <Route path="reports/journal-entries-party-ledger" element={<JournalEntriesPartyLedgerReportPage />} />
          <Route path="reports/day-book" element={<DayBookReportPage />} />
          <Route path="reports/cash-and-bank-report-all-payments" element={<CashAndBankReportAllPaymentsPage />} />
          <Route path="reports/expense-category-report" element={<ExpenseCategoryReportPage />} />
          <Route path="reports/cost-centre-report" element={<CostCentreReportPage />} />
          <Route path="reports/employee-ledger" element={<EmployeeLedgerPage />} />
          <Route path="reports/party-balances" element={<PartyBalancesPage />} />
          <Route path="reports/party-ledger-journal" element={<PartyLedgerJournalPage />} />
          <Route path="reports/migrate-journal-entries" element={<MigrateJournalEntriesPage />} />
          <Route path="report/*" element={<Navigate to="/reports" replace />} />
          <Route path="report" element={<Navigate to="/reports" replace />} />

          {/* Taxes / GST Settlement - Redirects to COA Taxes tab */}
          <Route path='taxes' element={<Navigate to="/coa/tax-settlement" replace />} />

          {/* Cost Centre routes */}
          <Route path='cost-centres' element={<ProtectedRoute><CostCentreManagement /></ProtectedRoute>} />

          {/* Chart of Accounts module: single sidebar entry -> tabbed layout like Inventory */}
          <Route path='coa' element={<ChartsOfAccount />}>
            <Route index element={<GroupCategories />} />
            <Route path='group-categories' element={<GroupCategories />} />
            <Route path='primary-groups' element={<PrimaryGroups />} />
            <Route path='sub-groups' element={<SubGroups />} />
            <Route path='ledgers' element={<Ledgers />} />
            <Route path='tax-settlement' element={<GSTSettlement />} />
            <Route path='expense-settlement' element={<ExpenseSettlement />} />
            <Route path='statutory-compliance' element={<StatutoryCompliance />} />
            <Route path='cost-centres' element={<CostCentreManagement />} />
          </Route>
          <Route path='charts-of-account' element={<Navigate to="/coa" replace />} />
          <Route path='charts-of-account/*' element={<Navigate to="/coa" replace />} />
          <Route path='coa-dashboard' element={<CoaDashboard />} />

          <Route path='audit-log' element={<ProtectedRoute><AuditLog /></ProtectedRoute>} />
          <Route path='account-management' element={<AccountManagement />} />
          <Route path='my-profile' element={<MyProfile />} />
          <Route path='how-to-use' element={<HowToUseMagnus />} />
          <Route path='live-chat-support' element={<LiveChatSupport />} />
          <Route path='settings' element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path='payments/receipt-application' element={<ReceiptApplication />} />
          <Route path='access-denied' element={<AccessDenied />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
